/**
 * @author PoornaChandu
 * @description 
 */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import {StyledHomepage} from '../../commons/styles/layout';
import FilterComponent from './FilterComponent';
import DataComponent from './DataComponent';
const Trends =() =>{
  const [filterData,setFilterData] = useState([]);
  const [allFilterData,setAllFilterData] = useState([]);
  const [operatorList,setOperatorList] = useState([]);
  const [observationList,setObservationList] = useState([]);
  const [type,setType] = useState('');
  const getOperatorList = (OperatorList) => {
    setOperatorList(OperatorList);
  };
  const getFilterationData = (filterData, allFilterData) => {
    setFilterData(filterData);
    setAllFilterData(allFilterData);
    setType(filterData && filterData[0] && filterData[0].CodeType);
  };
 const getObservationList = (ObservationList) => {
    setObservationList(ObservationList);
    // this.props.ObservationList(ObservationList)
  };
    return (
      <StyledHomepage>
        <FilterComponent
          generateData={getFilterationData}
          OperatorList={getOperatorList}
          ObservationList={getObservationList}
          obList={observationList}
        />
        <DataComponent
          FilterData={filterData}
          AllFilterData={allFilterData}
          OperatorList={operatorList}
          ObservationList={getObservationList}
          CodeType={type}
        />
      </StyledHomepage>
    );
};
const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache,
  currentTimeZone: state.LayoutReducer.currentTimeZone
});
export default connect(mapStateToProps)(Trends);
